import maintainColumns from './columns/maintain'

export default [
  {
    type: 'MAINTAIN',
    name: '维保预警',
    columns: maintainColumns
  }
]
// export default {
//   air: {
//     name: '气量不足',
//     columns: airColumns
//   },
//   blocking: {
//     name: '空滤堵塞',
//     columns: blockingColumns
//   },
//   heat: {
//     name: '高温预警',
//     columns: heatColumns
//   },
//   inverter: {
//     name: '变频器高温',
//     columns: inverterColumns
//   },
//   low: {
//     name: '低温预警',
//     columns: lowColumns
//   },
//   overload: {
//     name: '空压机过载',
//     columns: overloadColumns
//   },
//   overflowing: {
//     name: '过流预警',
//     columns: overflowingColumns
//   }
// }